import { ISide } from '@/utils/drawing/types';

// Computes a hash for the side of a surface.
export function getSurfaceSideId(side: ISide): string {
  return `${side.start[0]}-${side.start[1]}-${side.end[0]}-${side.end[1]}`;
}
